import { throttle } from 'lodash';

interface ScrollTracker {
  10: number;
  25: number;
  50: number;
  75: number;
  100: number;
}

declare global {
  interface Window {
    tealiumScrollTracker: ScrollTracker;
  }
}

export function init() {
  // See requirements in GAPGLOBAL-1055
  // Global variable to keep track of which events we have already fired.
  window.tealiumScrollTracker = {
    10: 0,
    25: 0,
    50: 0,
    75: 0,
    100: 0
  };

  const fireScrollEvent = function (args) {
    args = args || {
      nonInteraction: false
    };

    // Capture the full length of the page
    const windowHeight = document.documentElement.scrollHeight;
    // Capture where the top of the page is after scroll
    const currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    // Capture how many pixels can be viewed by the user
    const windowViewingArea =
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // Figure out the bottom of what the user has scrolled to
    const bottomScrollPosition = currentPosition + windowViewingArea;
    // Figure out the rounded percentage of how much was scrolled
    const percentScrolled = parseInt(((bottomScrollPosition / windowHeight) * 100).toFixed(0)) + 1;

    for (const scrollBucket in window.tealiumScrollTracker) {
      if (Object.prototype.hasOwnProperty.call(window.tealiumScrollTracker, scrollBucket)) {
        if (
          window.tealiumScrollTracker[scrollBucket] === 0 &&
          percentScrolled >= parseInt(scrollBucket)
        ) {
          window.tealiumScrollTracker[scrollBucket] = 1;

          site.track.evtLink({
            event_name: 'user_scroll',
            event_category: 'Scroll Depth',
            event_action: document.location.href,
            event_noninteraction: args.nonInteraction ? 1 : 0,
            event_label: scrollBucket
          });

          if (scrollBucket === '100') {
            window.removeEventListener('scroll', fireScrollEvent);
          }
        }
      }
    }
  };

  fireScrollEvent({ nonInteraction: true });

  window.addEventListener('scroll', throttle(fireScrollEvent, 250));
}
